.root {
    background-color: var(--mantine-color-gneis-0);
    border: 1px solid var(--mantine-color-gneis-2);
    border-radius: var(--mantine-radius-sm);
    padding: var(--mantine-spacing-md);
    cursor: pointer;
}

.root::before {
    display: none;
}

.title {
    color: black;
    font-weight: 600;
}

.description {
    color: var(--mantine-color-dimmed);
}
